import {
  CompanySearch,
  ExportHistoryParams,
  TrendingTopicsParams,
} from '@/services/call-log-service/call-log-service.types';
import { AnnotationContext } from '@/services/conversations-service/conversations-service.types';
import {
  CallMetricsChartParams,
  DashboardFilters,
  SmsMetricsChartParams,
} from '@/services/dashboard-service/dashboard.service.types';
import { DocumentsFilters } from '@/services/documents-service/documents-service.types';
import { MaintenancesFilters } from '@/services/maintenances-service/maintenances-service.types';
import { SurveysFilters } from '@/services/surveys-service/surveys-service.types';

export const ReactQueryKeys = {
  USER: () => ['user'],
  AI_PERFORMANCE: (params: DashboardFilters) => ['ai-performance', params],
  CALL_METRICS: (params: DashboardFilters) => ['call-metrics', params],
  METRICS_CHART: (params: CallMetricsChartParams) => ['metrics-chart', params],
  SMS_METRICS: (params: DashboardFilters) => ['sms-metrics', params],
  SMS_METRICS_CHART: (params: SmsMetricsChartParams) => ['sms-metrics-chart', params],
  CALL_LOG: (params: DashboardFilters) => ['call-log', params],
  COMPANY_SEARCH: (params: CompanySearch) => ['company-search', params],
  CONVERSATIONS: (params: AnnotationContext) => ['conversations', params],
  CONVERSATIONS_REVIEWED: (params: AnnotationContext) => ['conversations-reviewed', params],
  INSIGHTS: (params: DashboardFilters) => ['insights', params],
  SMS_LOG: (params: DashboardFilters) => ['sms-log', params],
  EXPORT_HISTORY: (params: ExportHistoryParams) => ['export-history', params],
  EXPORT_HISTORY_CVS: () => ['export-history-csv'],
  EXPORT_CALL_LOGS: () => ['export-call-logs'],
  TRENDING_TOPICS: (params: TrendingTopicsParams) => ['trending-topics', params],
  SURVEYS: (params: SurveysFilters) => ['surveys', params],
  MAINTENANCES: (params: MaintenancesFilters) => ['maintenances', params],
  MAINTENANCE: (id: number) => ['maintenance', id],
  DOCUMENTS: (params: DocumentsFilters) => ['documents', params],
  DOCUMENT: (id: string) => ['document', id],
  INIT_MESS: (companyName?: string) => ['company-message', companyName],
  COMPANIES: () => ['companies'],
  BUSINESS_HOURS: (company_id?: string, date?: string) => ['business-hours', company_id, date],
  REDIRECTION_TARGETS: (company_id?: number) => ['redirection-targets', company_id],
  REDIRECTION_TARGET: (id: number) => ['redirection-target', id],
  RECORDING_URL: (conversationId?: number) => ['recording-url', conversationId],
} as const;
